import { SLACK_BOT_EXPRESS_APP_URL } from 'xm-constants/env';

export const SAVE_XM_CONFIG = 'SAVE_XM_CONFIG';
export const SAVE_XM_CONFIG_START = `${SAVE_XM_CONFIG}_START`;
export const SAVE_XM_CONFIG_SUCCESS = `${SAVE_XM_CONFIG}_SUCCESS`;
export const SAVE_XM_CONFIG_FAIL = `${SAVE_XM_CONFIG}_FAIL`;

export function saveXMConfig(params) {
  return {
    type: SAVE_XM_CONFIG,
    meta: {
      externalUri: true,
      method: 'post',
      uri: `${SLACK_BOT_EXPRESS_APP_URL}/xm/save-config`,
      params,
    },
  };
}
